module.exports = __webpack_public_path__ + "media/src/components/EmployerProfile/img/portalLogo-1df918316f2edcc9edf9577192ec8d5d.png";